function uniqueNodes(nodes) {
  return [...new Set(nodes)];
}

function normalizeColorValue(color) {
  if (!color) return '';

  if (typeof color === 'string') {
    return color.trim();
  }

  if (typeof color === 'object') {
    if (typeof color.hex === 'string') return color.hex;
    if (
      typeof color.red === 'number' &&
      typeof color.green === 'number' &&
      typeof color.blue === 'number'
    ) {
      if (typeof color.alpha === 'number') {
        return `rgba(${color.red}, ${color.green}, ${color.blue}, ${color.alpha})`;
      }
      return `rgb(${color.red}, ${color.green}, ${color.blue})`;
    }
    if (typeof color.value === 'string') return color.value;
  }

  return '';
}

function getCurrentVariantId() {
  const productFormInput = document.querySelector(
    'product-form form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] input[name="id"]'
  );
  if (productFormInput?.value) return productFormInput.value;

  const selectedVariantScript = document.querySelector('variant-picker [data-selected-variant]');
  if (selectedVariantScript?.textContent) {
    try {
      return JSON.parse(selectedVariantScript.textContent).id;
    } catch (error) {
      return null;
    }
  }

  return null;
}

function updateColorTargets(color) {
  const normalizedColor = normalizeColorValue(color);
  const targets = uniqueNodes([
    ...document.querySelectorAll('.flavor-color-box'),
    ...document.querySelectorAll('[data-flavor="color"]'),
  ]);

  targets.forEach((target) => {
    if (!normalizedColor) {
      target.style.removeProperty('background-color');
      return;
    }
    target.style.backgroundColor = normalizedColor;
  });
}

function updateFactsTargets(factsUrl, flavorName) {
  const targets = uniqueNodes([
    ...document.querySelectorAll('.flavor-facts-image'),
    ...document.querySelectorAll('[data-flavor="facts"]'),
  ]);

  targets.forEach((target) => {
    if (target.tagName !== 'IMG') return;

    if (factsUrl) {
      target.src = factsUrl;
      target.hidden = false;
    } else {
      target.removeAttribute('src');
      target.hidden = true;
    }

    target.alt = `${flavorName || 'Flavor'} Supplement Facts`;
  });
}

function updateNameTargets(flavorName) {
  const targets = document.querySelectorAll('[data-flavor="name"]');
  targets.forEach((target) => {
    target.textContent = flavorName || '';
  });
}

function updateFlavorUI(variantId) {
  if (!window.variantFlavorData || !variantId) return;

  const data = window.variantFlavorData[String(variantId)];
  if (!data) return;

  updateColorTargets(data.color);
  updateFactsTargets(data.facts, data.name);
  updateNameTargets(data.name);
}

function syncFlavorFromCurrentVariant() {
  const currentVariantId = getCurrentVariantId();
  if (currentVariantId) {
    updateFlavorUI(currentVariantId);
  }
}

document.addEventListener('DOMContentLoaded', syncFlavorFromCurrentVariant);
document.addEventListener('shopify:section:load', syncFlavorFromCurrentVariant);

document.addEventListener('variant:changed', (event) => {
  const variant = event?.detail?.variant;
  if (variant?.id) {
    updateFlavorUI(variant.id);
  }
});

// Legacy compatibility with any custom emitters.
document.addEventListener('variant:change', (event) => {
  const variant = event?.detail?.variant;
  if (variant?.id) {
    updateFlavorUI(variant.id);
  }
});

document.addEventListener('change', (event) => {
  if (event.target?.name === 'id' && event.target.value) {
    updateFlavorUI(event.target.value);
  }
});
